export default __webpack_public_path__ + "static/esg_governance_box_d-fa45d3a3f5e7d50cf9dda39dd531841f.png";